import { hotkeyHint } from "@/hooks/useCoverageBetaHotkeys";
import { useCoverageBetaStore } from "@/store/useCoverageBetaStore";
import { QUERY_IMAGE_CONTROL_ICON_SIZE } from "@/utils/utils";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconSquareDashed } from "@tabler/icons-react";

export const DrawBoxMode = () => {
  const activeMode = useCoverageBetaStore((s) => s.activeMode);
  const setActiveMode = useCoverageBetaStore((s) => s.setActiveMode);
  const recordInteraction = useCoverageBetaStore((s) => s.recordInteraction);
  const thisMode = "draw-box";

  return (
    <Tooltip
      label={`Draw Empty Area (${hotkeyHint("draw_box")})`}
      position="right"
    >
      <ActionIcon
        size="sm"
        variant={activeMode === thisMode ? "filled" : "light"}
        color={activeMode === thisMode ? "violet" : "gray"}
        onClick={() => {
          setActiveMode(thisMode);
          recordInteraction("draw_box", "click");
        }}
      >
        <IconSquareDashed size={QUERY_IMAGE_CONTROL_ICON_SIZE} />
      </ActionIcon>
    </Tooltip>
  );
};
